import { BaseModel } from '../../_base/crud';

export class Timeline extends BaseModel {
  id: number;
  subject: string;
  type: string;
  from_time: Date;

  clear() {
    // Intentional no-op: Method will be implemented by subclasses
  }
}
